<template>
  <div class="team-players-table">
    <h4 v-if="title">{{ title }}</h4>
    <table v-if="players.length">
      <tr>
        <td>Nick</td>
        <td>{{ gameIdLabel }}</td>
        <td>Username</td>
      </tr>
      <tr v-for="player in players" :key="'player-' + player.userId">
        <td>{{ player.nick || '-' }}</td>
        <td>{{ player.gameId || '-' }}</td>
        <td>
          <router-link v-if="player.userId"
                       :to="{ name: 'user_info', params: { id: player.userId } }"
                       target="_blank"
                       v-b-tooltip.hover.top="'Открыть страницу игрока'"
                       class="player-link">
            {{ player.username || player.userId }}
            <i class="fa fa-external-link"></i>
          </router-link>
          <template v-else>{{ player.username || '-' }}</template>
        </td>
      </tr>
    </table>
    <div v-else class="pug">
      Игроков нет
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

/**
 * Состав команды в карточках менеджмента команд этапа.
 *
 * Карточки получают игроков из разных ручек и в разной форме, поэтому
 * сюда приходит уже приведённый список: { userId, username, nick, gameId }.
 */
export default {
  name: "TeamPlayersTable",
  props: {
    players: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('moduleNewTournament', ['tournament']),
    gameIdLabel() {
      return this.tournament?.game?.slug === 'mlbb' ? 'MLBB ID' : 'PUBG ID'
    }
  }
}
</script>

<style scoped lang="scss">
.team-players-table {
  margin-top: 20px;
  width: 100%;

  @media screen and (max-width: 400px) {
    overflow-x: scroll;
  }

  h4 {
    font-size: 15px;
    text-align: center;
    margin-bottom: 10px;
  }

  .pug {
    text-align: center;
    color: #808080c7;
  }

  .player-link {
    color: #7366ff;

    i {
      font-size: 11px;
      margin-left: 4px;
    }
  }

  table {
    width: 100%;

    td {
      padding: 10px;

      @media screen and (max-width: 800px) {
        font-size: 12px;
      }
    }

    & > tr:not(:last-child) {
      border-bottom: 1px solid #00000026;
    }

    & > tr:not(:first-child):hover {
      background: #00000010;
    }

    & > tr > td:not(:last-child) {
      border-right: 1px solid #00000026;
    }

    & > tr > td:not(:first-child) {
      text-align: center;
    }
  }
}
</style>
